import styled from 'styled-components';
import { vars, pxToRem, media } from '$util/theme';
import Form from '$components/composite/Form';

export default styled(Form)`
  position: relative;
  z-index: 1;
  button {
    box-shadow: 0px 2px 16px 4px rgba(255, 255, 255, 0.16);
    width: 100%;
  }

  .input-group {
    .FormItem {
      margin: 0 auto ${pxToRem(16)};
    }
    .item-error {
      color: ${vars.quantumverse.reskinColors.red200} !important;
      font-size: ${pxToRem(13)} !important;
      text-align: left;
    }
    .ant-form-item-has-error {
      input {
        border: 2px solid #ff4d4f !important;
      }
    }
  }

  ${media.up('lg')} {
    .footer-group {
      margin-top: ${pxToRem(24)};
    }
  }
`;
